import { useTranslation } from 'react-i18next';

export default function Reputation() {
  const { t } = useTranslation();

  const testimonials = [
    {
      username: '追番小达人',
      role: '忠实用户',
      content: t('用户评价1'),
    },
    {
      username: '二次元老宅',
      role: '资深用户',
      content: t('用户评价2'),
    },
    {
      username: '樱花下的猫',
      role: '活跃用户',
      content: t('用户评价3'),
    },
    {
      username: '动漫鉴赏师',
      role: 'VIP用户',
      content: t('用户评价4'),
    },
    {
      username: '深夜追番人',
      role: '长期用户',
      content: t('用户评价5'),
    },
    {
      username: '内容创作者小王',
      role: '合作方',
      content: t('用户评价6'),
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-background-200/70">
      <div className="px-4 md:px-6">
        <div className="mb-8">
          <span className="inline-block bg-accent-100 text-accent-900 text-xs font-medium px-3 py-1 rounded-lg whitespace-nowrap">
            {t('合作伙伴与用户说')}
          </span>
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mt-3 leading-tight">
            {t('各界对樱花动漫的评价')}
          </h2>
        </div>

        <div className="columns-1 md:columns-3 gap-4 space-y-4">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="break-inside-avoid bg-background-50 rounded-lg p-4 md:p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-heading text-sm">
                    {item.username.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{item.username}</p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                &ldquo;{item.content}&rdquo;
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-background-50 rounded-lg p-5">
            <p className="text-sm text-foreground-700 leading-relaxed">
              &ldquo;{t('合作方评价1')}&rdquo;
            </p>
            <p className="text-xs text-foreground-500 mt-3">— 某知名动漫内容商</p>
          </div>
          <div className="bg-background-50 rounded-lg p-5">
            <p className="text-sm text-foreground-700 leading-relaxed">
              &ldquo;{t('合作方评价2')}&rdquo;
            </p>
            <p className="text-xs text-foreground-500 mt-3">— 独立动画制作人</p>
          </div>
        </div>
      </div>
    </section>
  );
}